import { RouteConfig } from 'vue-router'
import http from '@plugin/axios'
import purchaserRoutes from './purchaser-routes'
import supplierRoutes from './supplier-routes'
import settingRoutes from './setting-routes'

abstract class Router {
  static getRouter: RouteConfig
  abstract getMenus(): Promise<any>
}

class Purchaser extends Router {
  static getRouter = {
    path: '/purchaser',
    name: 'Root.Purchaser',
    component: { render: (h: any) => h('router-view') },
    redirect: { name: 'Dashboard' },
    children: purchaserRoutes
  }
  getMenus = function() {
    return http({
      useFactory: false,
      url: '/sysMenu/getUserMenuTree',
      data: {}
    })
  }
}

class Supplier extends Router {
  static getRouter = {
    path: '/supplier',
    name: 'Root.Supplier',
    component: { render: (h: any) => h('router-view') },
    redirect: { name: 'Dashboard' },
    children: supplierRoutes
  }
  getMenus = function() {
    return http({
      useFactory: false,
      url: '/sysMenu/getUserMenuTree',
      data: {}
    })
  }
}

class Setting extends Router {
  static getRouter = {
    path: '/setting',
    name: 'Root.Setting',
    component: { render: (h: any) => h('router-view') },
    redirect: { name: 'Root.Setting.Dashboard' },
    children: settingRoutes
  }
  getMenus = function() {
    return http({
      useFactory: false,
      url: '/sysMenu/getPlatformMenuTree',
      data: {}
    })
  }
}

export { Purchaser, Supplier, Setting }

interface Fun {
  (): Promise<any>;
}
const map = new Map<string, Fun>([['Root.Purchaser', new Purchaser().getMenus], ['Root.Supplier', new Supplier().getMenus], ['Root.Setting', new Setting().getMenus]])
export default map
